<template>
  <div class="row" ref="container">
    <div :class="listStyle">
      <List :__list="dataArray" :__isOnLoad="isListOnload" :isLightMode="isLightMode"></List>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import List from './List';
export default {
  components: {
    List,
  },
  props: {
    PID: {
      type: String,
      default: () => {
        return '';
      },
    },
    isLightMode: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },

  data() {
    return {
      moduleRoute: '/devis',
      isListOnload: false,
      dataArray: [],
      onGoingReq:[],
      intervalID: null,
      admin: null,
    };
  },

  computed: {
    listStyle() {
      return this.$props.isLightMode ? 'col-md-12' : 'col-md-12';
    },

  },

  methods: {
    resolveExercice() {
      const fromCookie = Vue.$cookies.get("exercice");
      const archive = String(fromCookie || new Date().getFullYear());

      if (!fromCookie) {
        Vue.$cookies.set("exercice", archive);
      }

      return archive;
    },

    handleArchiveChange() {
      this.loadData();
    },

    handleDocumentRefresh(payload = {}) {
      if (!payload.module || payload.module === "devis") {
        this.loadData();
      }
    },

    getDeleteErrorMessage(error, documentLabel) {
      const payload =
        error && error.response && error.response.data ? error.response.data : {};

      if (payload.error === "NOT_LAST_DOCUMENT") {
        return `Seul le dernier ${documentLabel} peut être supprimé.`;
      }

      if (payload.error === "LINKED_DOCUMENTS_EXIST") {
        return "Supprimez d'abord les documents liés avant de supprimer ce document.";
      }

      if (payload.error === "DOCUMENT_NOT_FOUND") {
        return `Ce ${documentLabel} est introuvable.`;
      }

      return `La suppression du ${documentLabel} a échoué.`;
    },


    setUpdateValue(id, val, flag) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        this.dataArray[idx][flag] = val;
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id', flag]);
      data[flag] = val;
      this.updateAction({ $onNext, $onError, $onComplete, data });
    },

    deleteAction(id) {
      const findIdx = (element) => element._id == id;
      var idx = this.dataArray.findIndex(findIdx);
      this.onGoingReq.push({});
      let $onNext = (response) => {
        if (response.data == 'OK') {
          this.dataArray.splice(idx, 1);
        }
      };

      const $onError = (error) => {
        this.$bvToast.toast(this.getDeleteErrorMessage(error, "devis"), {
          title: "Suppression devis",
          variant: "danger",
          solid: true,
        });
      };
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      let data = this._.pick(this.dataArray[idx], ['_id']);
      this.__.httpAction({
        methode: 'DELETE',
        route: this.moduleRoute+"/"+data._id,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    updateAction(conf) {
      this.__.httpAction({
        methode: 'POST',
        route: this.moduleRoute,
        data: conf.data,
        onNext: conf.$onNext,
        onError: conf.$onError,
        onComplete: conf.$onComplete,
      });
    },

    loadData(id = null, cb = null, putAt = null) {
      if( undefined === this.$refs.container)
        return
      let $onNext = (response) => {
        this.dataArray = response.data;
          if (cb) cb();
        
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      const exercice = this.resolveExercice();
      var path = this.moduleRoute+'/'+exercice;

      if(id === null) {
        if(this.admin.type === 'CLIENT' && !this.$props.isLightMode) {
          path = path+'/byclient/'+this.admin.pid
        }

        else if(this.$props.PID !== '') {
          path = path+'/byparent/'+this.$props.PID
        }
        
      }
      this.onGoingReq.push({});
      this.__.httpAction({
        methode: 'GET',
        route: path+ (id != null ? '/'+id : '/'),
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

  },
  mounted() {

      this.admin = Vue.$cookies.get("user");
      this.loadData();
      if(!this.$props.isLightMode) {
        this.$root.$on("documents:refresh", this.handleDocumentRefresh);
        this.$root.$on("archive:changed", this.handleArchiveChange);
      }

      if(this.intervalID === null && !this.$props.isLightMode) {
        this.intervalID = setInterval(()=> {
            this.loadData();}
          , 10000)
      }

  },

  beforeDestroy() {
    if(!this.$props.isLightMode) {
      this.$root.$off("documents:refresh", this.handleDocumentRefresh);
      this.$root.$off("archive:changed", this.handleArchiveChange);
    }
  },

  watch: {
    onGoingReq: function () {
      this.isListOnload = this.isEditOnload = this.onGoingReq.length > 0;
    },
    $props: {
      deep: true,
      handler(newValue, oldValue) {
        this.loadData();
      },
    },
  },
};
</script>
<style></style>
